var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDdBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 395.55,
    height: 36.584,
    viewBox: "0 0 395.55 36.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 395.55,
    height: 36.583,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.456,34.745h8.8l6.812-18.052L93,4.163Z",
    transform: "translate(35.934 1.836)",
    fill: "#050605"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.656,0l12.6,36.581h8.7L100.361,0Z",
    transform: "translate(40.434)",
    fill: "#050605"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.264,
    height: 8.23,
    transform: "translate(79.896 0.001)",
    fill: "#050605"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8.23,
    height: 24.691,
    transform: "translate(90.412 11.889)",
    fill: "#050605"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.748,34.745h8.8l6.812-18.052L36.289,4.163Z",
    transform: "translate(10.918 1.836)",
    fill: "#050605"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.948,0l12.6,36.581h8.7L43.654,0Z",
    transform: "translate(15.417)",
    fill: "#050605"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.146,36.581H0V29.264H9.146a10.974,10.974,0,1,0,0-21.947H0V0H9.146a18.29,18.29,0,0,1,0,36.581",
    transform: "translate(0 -0.001)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.041,34l8.229,0h0l.2-17.372-8.1-10.752Z",
    transform: "translate(110.305 2.588)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.819,25.383h0Z",
    transform: "translate(119.911 11.197)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.142,36.58V0h-8.23V22.66L260.451,0H250.277L276.855,36.58h8.287Z",
    transform: "translate(110.409 -0.001)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.435,
    height: 8.23,
    transform: "translate(323.909)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.461,
    height: 8.23,
    transform: "translate(323.909 14.632)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.435,
    height: 8.23,
    transform: "translate(323.909 28.349)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.19,0h0L211.65,30.581l-4.07-12.528L214.392,0Z",
    transform: "translate(91.573 -0.001)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.433,0h8.7l12.6,36.581h-8.706Z",
    transform: "translate(85.332 0)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.23,
    height: 36.581,
    transform: "translate(261.389 -0.001)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.626,20.294A11.888,11.888,0,0,0,171.22,0H152.93V8.23h18.29a3.658,3.658,0,0,1,0,7.315H152.93V36.579h8.23v-12.8H165.3l9.3,12.8h10.176L175.02,23.146a11.791,11.791,0,0,0,4.606-2.852",
    transform: "translate(67.464 -0.001)",
    fill: "#050605"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.001,
    transform: "translate(252.243 36.579)",
    fill: "none",
    stroke: "#050605",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.693,36.581h-9.146V29.264h9.146a10.974,10.974,0,1,0,0-21.947h-9.146V0h9.146a18.29,18.29,0,0,1,0,36.581",
    transform: "translate(56.267 -0.001)",
    fill: "#050605"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdBlack);
export default __webpack_public_path__ + "static/media/dd-black.188f33b38bc7b4bc6c8f32497111cac0.svg";
export { ForwardRef as ReactComponent };